// automatically generated by the FlatBuffers compiler, do not modify
export var GeometryType;
(function (GeometryType) {
    GeometryType[GeometryType["Unknown"] = 0] = "Unknown";
    GeometryType[GeometryType["Point"] = 1] = "Point";
    GeometryType[GeometryType["LineString"] = 2] = "LineString";
    GeometryType[GeometryType["Polygon"] = 3] = "Polygon";
    GeometryType[GeometryType["MultiPoint"] = 4] = "MultiPoint";
    GeometryType[GeometryType["MultiLineString"] = 5] = "MultiLineString";
    GeometryType[GeometryType["MultiPolygon"] = 6] = "MultiPolygon";
    GeometryType[GeometryType["GeometryCollection"] = 7] = "GeometryCollection";
    GeometryType[GeometryType["CircularString"] = 8] = "CircularString";
    GeometryType[GeometryType["CompoundCurve"] = 9] = "CompoundCurve";
    GeometryType[GeometryType["CurvePolygon"] = 10] = "CurvePolygon";
    GeometryType[GeometryType["MultiCurve"] = 11] = "MultiCurve";
    GeometryType[GeometryType["MultiSurface"] = 12] = "MultiSurface";
    GeometryType[GeometryType["Curve"] = 13] = "Curve";
    GeometryType[GeometryType["Surface"] = 14] = "Surface";
    GeometryType[GeometryType["PolyhedralSurface"] = 15] = "PolyhedralSurface";
    GeometryType[GeometryType["TIN"] = 16] = "TIN";
    GeometryType[GeometryType["Triangle"] = 17] = "Triangle";
})(GeometryType || (GeometryType = {}));
